import {useMutation} from "@tanstack/react-query";
import client from "../../utils/Client";

export const useLogin = () => {
    const login = (payload) => client.post("auth/login", payload);
    return useMutation((payload) => login(payload));
}